import { styled } from '@linaria/react';

import { TOC_THRESHOLD } from '@/components/ContentGrids/TutorialGrid';

const TOC_PLUS_1PX = TOC_THRESHOLD + 0.0625;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0;
  margin-top: 3rem;
  margin-inline: -4rem;
  margin-bottom: 4rem;

  @media (max-width: 51rem),
    (min-width: ${TOC_PLUS_1PX}rem) and (max-width: 70.625rem) {
    margin-inline: 0;
  }
  @media (max-width: 37rem) {
    flex-direction: column;
  }
`;

export const Label = styled.div`
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
  transform: translateY(-100%);
  font-size: 0.875rem;
  text-transform: uppercase;
  font-weight: var(--font-weight-bold);
  text-align: center;

  @media (max-width: 37rem) {
    display: none;
  }
`;
